import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-73" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-2xl" data-id="element-74" data-mp="1ge0ewllrkscj">
        <h2 className="text-center text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.4rem]" data-id="element-75" data-mp="2e0fypu1ny239">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-76" data-mp="2924mjcnwbfhv">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl bg-white" data-id="element-77" data-mp="1z3fh4jd6rnii" data-mpi={index}>
                <h3 data-id="element-78" data-mp="1z5jhwsfsg6ek">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500/40" data-id="element-79" data-mp="smv4ilyles9m">
                    <span className="text-sm font-bold text-stone-900" data-id="element-80" data-mp="pfv1k89pwubz">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-red-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-81" data-mp="ugitqx9onh7s" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-82" data-mp="kkxw1bbnd33u">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-83" data-mp="6qexxc2qklrc">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-stone-600" data-id="element-84" data-mp="3jyi373mg4r93">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}